
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/approvability",
      function () {
        return require("private-next-pages/tools/approvability.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/approvability"])
      });
    }
  